import { render, staticRenderFns } from "./Ja.vue?vue&type=template&id=676bcbeb"
import script from "./Ja.vue?vue&type=script&lang=js"
export * from "./Ja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports